import { EMAIL, PASSWORD } from "./consts";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { useGetLoggedInUser, useLoginMutation } from "@/services";
import { toast } from "sonner";
import { setCookie } from "@/lib/setCookie";
import { routes } from "@/routes/utils";
import { getRequiredFields, removeEmptyFields } from "@/lib/utils";
import { setLoggedInUserData } from "@/redux/slices";
import { useDispatch } from "react-redux";
import { schema } from "./validations";

const useLogin = () => {
  const navigate = useNavigate();
  const [isPassword, setIsPassword] = useState<boolean>(true);
  const dispatch = useDispatch();

  const form = useForm<any>({
    defaultValues: {
      [EMAIL]: "",
      [PASSWORD]: "",
    },
    resolver: zodResolver(schema),
  });

  // Dynamically determine required fields
  const requiredFields = getRequiredFields(schema);

  const { data: loggedInUserData, refetch: refetchLoggedInUser } =
    useGetLoggedInUser({
      queryParams: {
        enabled: false,
      },
    });

  const { mutate: loginMutate, isPending: isLoginPending } = useLoginMutation({
    onError: (error?: any) => {
      toast.error(
        typeof error?.response?.data?.issues?.message === "string"
          ? error?.response?.data?.issues?.message
          : typeof error?.response?.data?.message === "string"
          ? error?.response?.data?.message
          : "Something went wrong",
        {
          className: "!bg-red-500 !text-white",
        }
      );
      return error?.response?.data?.message;
    },
    onSuccess: (data) => {
      if (data?.data?.data?.access_token) {
        refetchLoggedInUser();
        setCookie("accessToken", data?.data?.data?.access_token);
        navigate(`/${routes.admin}`);
      }
    },
  });

  useEffect(() => {
    if (loggedInUserData) {
      dispatch(setLoggedInUserData(loggedInUserData?.data));
    }
  }, [loggedInUserData]);

  const onSubmit = (data: any) => {
    const _data = removeEmptyFields(data);
    // navigate(`/${routes.admin}`);
    loginMutate({ data: _data });
  };

  const onEyeIconClick = () => {
    setIsPassword(!isPassword);
  };

  const Icon = isPassword ? Eye : EyeOff;

  const onForgotClick = () => {
    navigate(`/${routes.forgotPassword}`);
  };
  return {
    navigate,
    form,
    requiredFields,
    onSubmit,
    onEyeIconClick,
    isPassword,
    Icon,
    isLoginPending,
    onForgotClick,
  };
};

export default useLogin;
